// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = Partial<WidgetProps> & HasProduct;

export interface ProductDetailsBrandStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    brandName?: TypographyPresentationProps;
}

export const productBrandStyles: ProductDetailsBrandStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-right: 50px;
        `,
    },
    labelText: {
        size: fontConfig.fontSize.small,
        lineHeight: "20px",
        weight: fontConfig.weight.bold,
    },
    brandName: {
        size: fontConfig.fontSize.small,
        lineHeight: "20px",
    },
};

const styles = productBrandStyles;

const ProductDetailBrand: React.FC<Props> = ({ product }) => {
    if (!product || !product.brand?.name) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.labelText}>{translate("Brand:")}&nbsp;</Typography>
            <Typography {...styles.brandName}>{product.brand.name}</Typography>
        </StyledWrapper>
    );
};

export const ProductDetailBrandComponent: React.FC<Props> = ProductDetailBrand;

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailBrand),
    definition: {
        displayName: "Product Brand",
        group: "XNGAGE" as any,
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
